import React from "react";
import { StyledModal } from "./Modal.styled";
import { TitlesTyp } from "../../Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { IconManager } from "../IconManager/IconManager";
import { ReactComponent as CloseIcon } from "../../../icons/closeCircle.svg";
import ReactDOM from "react-dom";

type ModalProps = {
  label: string;
  children: React.ReactNode;
  isOpen: boolean;
  closeModal?: () => void;
  rightButton?: React.ReactNode;
  leftButton?: React.ReactNode;
  message?: React.ReactNode;
  fullSize?: boolean;
  fullScreen?: boolean;
};

export const Modal = ({
  label,
  children,
  closeModal,
  isOpen,
  rightButton,
  leftButton,
  fullSize,
  fullScreen,
  message,
}: ModalProps) => {
  if (!isOpen) {
    return null;
  }

  const showFooter = leftButton !== undefined || rightButton !== undefined;

  return ReactDOM.createPortal(
    <StyledModal
      className="modal-overlay"
      $showFooter={showFooter}
      $fullSize={fullSize}
      $fullScreen={fullScreen}
    >
      <div className="modal-box">
        <div className="modal-header">
          <TitlesTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
            {label}
          </TitlesTyp>
          {closeModal && (
            <IconManager size={IconSizeEnum.SMALL} onClick={() => closeModal()}>
              <CloseIcon data-testid="close-button" />
            </IconManager>
          )}
        </div>
        <div className="modal-content">{children}</div>
        {showFooter && (
          <div className="modal-footer">
            <div className="modal-footer-left">{message}</div>
            <div className="modal-footer-right">
              {leftButton}
              {rightButton}
            </div>
          </div>
        )}
      </div>
    </StyledModal>,
    document.body,
  );
};
